import Tooltip from 'components/Tooltip';
import PropTypes from 'prop-types';
// Import utilities
/**
 * 
 * @param {data} param0 
 * @returns 
 */

function Card01({
    title,
    description,
    value,
    icon,
    color,
    className
}) {
    // flex flex-col sm:col-span-6 xl:col-span-4 bg-white shadow-sm rounded-sm border border-gray-200
    return (
        <div className={`relative flex flex-col bg-white border rounded-md border-gray-200 shadow-sm p-4 ${className}`} >
            <header className="flex justify-between items-start mb-1">
                <div className="flex justify-items-center w-full">
                    <p className="font-semibold text-gray-700 mb-2 text-ellipsis truncate xl:text-sm capitalize">{title}</p>
                    {!!description && <Tooltip className="ml-2">
                        <p  className="font-semibold text-gray-800 mb-1 ">{title}</p>
                        <p className="text-sm leading-4 text-gray-600 pb-3" style={{ whiteSpace: 'pre-line' }}>{description}</p>
                    </Tooltip>}
                </div>

            </header>
            <div className='flex justify-between'>

                {/* Icon */}
                <div className={`p-2 text-xl ${color ? 'text-' + color + '-500' : 'text-blue-500'} ${color ? 'bg-' + color + '-100' : 'bg-blue-100'}  rounded-xl`}>
                    {/* <img src={Icon} width="24" height="24" alt="Icon 02" className='align-middle ' /> */}
                    
                    {icon}
                </div>
                <div className="flex items-start">
                    <div className={`font-bold mr-2 text-lg text-gray-800`}>{value}</div>
                    {/* <div className="text-sm font-semibold text-white px-1.5 bg-yellow-600 rounded-full">-14%</div> */}
                </div>
            </div>


        </div>
    );
}

Card01.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.any,
  icon: PropTypes.node,
  color: PropTypes.string,
  className: PropTypes.string,
};

export default Card01;
